var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sleepBreathes"},[_c('div',{staticClass:"eacharts"},[_c('echarts',{attrs:{"chart-id":'sleepBreathes',"chart-option":_vm.options}})],1),_c('div',{staticClass:"title"},[_vm._v("睡眠得分")])])}
var staticRenderFns = []

export { render, staticRenderFns }